import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav>
      <NavLink to="/" className="nav-logo" style={{ textDecoration: 'none' }}>
        <span className="nav-logo-name">Zah<span className="brand-accent">e</span>la</span>
        <span className="nav-logo-tagline">Growth. Outbound. Results.</span>
      </NavLink>

      <ul className={`nav-links${open ? ' open' : ''}`}>
        <li><NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setOpen(false)}>Home</NavLink></li>
        <li><NavLink to="/services" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setOpen(false)}>Services</NavLink></li>
        <li><NavLink to="/sales-system" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setOpen(false)}>Sales System</NavLink></li>
        <li><NavLink to="/case-studies" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setOpen(false)}>Case Studies</NavLink></li>
        <li><NavLink to="/criteria" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => setOpen(false)}>Criteria</NavLink></li>
        <li>
          <NavLink to="/contact" className="nav-cta" onClick={() => setOpen(false)}>
            Get in Touch
          </NavLink>
        </li>
      </ul>

      <button className="nav-mobile-btn" onClick={() => setOpen(!open)} aria-label="Toggle menu">
        {open ? <X size={22} /> : <Menu size={22} />}
      </button>
    </nav>
  );
}
